import { render } from "./Game.vue?vue&type=template&id=da043a14&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=da043a14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da043a14"

export default script